// extracted by mini-css-extract-plugin
module.exports = {"Media":"Media_Media__20pW7","cover":"Media_cover__rtNtQ","image":"Media_image__uSKGz","video":"Media_video__gOXsr"};